<script lang="ts">
  import { Pages } from "@packages/utils/enums";

  import SignoutIcon from "@packages/ui/images/signout.svg";
  import AccountIcon from "@packages/ui/images/account.svg";
  import QrCodeIcon from "@packages/ui/images/qrcode.svg";
  import ScanIcon from "@packages/ui/images/scanner.svg";
  import BuyTokenIcon from "@packages/ui/images/buyToken.svg";
  import AssetsIcon from "@packages/ui/images/assets.svg";

  export let onClick: (page: Pages) => void = () => {};
  export let showAssets: boolean = false;

  const menuItems = [
    {
      title: "Sign Out",
      icon: SignoutIcon,
      page: Pages.LOGOUT,
    },
    {
      title: "Show ID",
      icon: QrCodeIcon,
      page: Pages.PASSPORT_ID,
    },
    {
      title: "PassScan",
      icon: ScanIcon,
      page: Pages.SCANNER,
    },
    {
      title: "Wallet",
      icon: BuyTokenIcon,
      page: Pages.WALLET,
    },
    {
      title: "Assets",
      icon: AssetsIcon,
      page: Pages.ASSETS,
      condition: showAssets,
    },
    {
      title: "My Account",
      icon: AccountIcon,
      page: Pages.PROFILE,
    },
  ];

  const visibleItems = menuItems.filter(
    (item) => !item.condition || item.condition,
  );
</script>

<div class="crtw-w-full crtw-flex crtw-flex-col crtw-gap-3 crtw-px-6 crtw-py-3">
  {#each visibleItems as item (item.page)}
    <button
      on:click={() => onClick(item.page)}
      class="crtw-flex crtw-items-center crtw-gap-2 crtw-w-full crtw-p-2 crtw-rounded-md crtw-border crtw-border-black crtw-cursor-pointer crtw-transition-all crtw-duration-200 crtw-active:scale-95"
    >
      <img
        src={item.icon}
        alt=""
        class="crtw-w-6 crtw-h-6 crtw-flex-shrink-0"
      />
      <span class="crtw-text-base crtw-font-medium crtw-flex-1 crtw-text-left">
        {item.title}
      </span>
    </button>
  {/each}
</div>
